import { ReactComponent as CoSafeLogo } from '../../../assets/brand/logo-with-text.svg';
import { ReactComponent as BackBtn } from '../../../assets/icons/arrow-left--yellow.svg';
import { ReactComponent as BackBtnWhite } from '../../../assets/imgs/chats/back-btn-white.svg';
import { useAppSelector } from '../../../hooks';
import {
  selectAllTenantSessions,
  selectTenant,
} from '../../../containers/Organizations/OrganizationsSlice';
import { TenantDropdown } from '../../../containers/Organizations/TenantDropdown/TenantDropdown';
import { isMultiOrgFeatureEnabled } from '../../../utils/features';
import DotsHorizontal from '../../../assets/icons/dots-three-horizontal.svg';
import { SilentModeHeader } from '../../SilentModeHeader';
import { translate } from '../../../utils/translate';
import _ from 'lodash';
import type { ReactNode } from 'react';
import {
  SHeaderWrapper,
  SHeader,
  Logo,
  SBalanceSpace,
  SLink,
  SSideMenu,
  SDots,
  SHeaderMessageWrapper,
  HeaderMessageText,
  SSubMessageText,
  SHeaderContent,
} from './Header.styles';

type IHeaderProps = {
  isMessageLayout: boolean;
  message: string;
  noTranslate: boolean;
  to?: string;
  backBtn?: boolean;
  showCoSafeLogo?: boolean;
  subMessageText?: string | null;
  subMessageType?: 'default' | 'accent';
  showDots?: boolean;
  dotsCallBack?: () => void;
  handleHeaderContentClick?: () => void;
  backgroundColor?: string | null;
  backBtnCallBack?: (e: any) => void;
  renderCustomRightButton?: () => ReactNode;
  showTenantSwitcher?: boolean;
  belowHeaderContent?: ReactNode;
};

export const Header = (props: IHeaderProps) => {
  const {
    isMessageLayout,
    message,
    noTranslate,
    to,
    backBtn,
    showCoSafeLogo,
    subMessageText,
    subMessageType = 'default',
    showDots,
    dotsCallBack,
    handleHeaderContentClick,
    backgroundColor,
    backBtnCallBack,
    renderCustomRightButton,
    showTenantSwitcher,
    belowHeaderContent,
  } = props;
  const tenant = useAppSelector(selectTenant);
  const tenantSessions = useAppSelector(selectAllTenantSessions);
  // Show tenant switcher only when enabled and sessions are available.
  const renderTenantSwitcher =
    !!showTenantSwitcher && isMultiOrgFeatureEnabled() && tenantSessions.length > 0;

  return (
    <SHeaderWrapper id="headerWrapper">
      <SHeaderContent>
        <SHeader id="header" extra={!isMessageLayout && !to} backgroundColor={backgroundColor}>
          {!isMessageLayout && (
            <>
              {backBtn && to ? (
                <SLink to={to} role="backButton">
                  <BackBtn />
                </SLink>
              ) : (
                <SBalanceSpace role="whiteSpace" />
              )}
              {renderTenantSwitcher ? (
                <TenantDropdown />
              ) : showCoSafeLogo || !tenant?.logoUrl ? (
                <CoSafeLogo id="cosafeLogo" />
              ) : (
                <Logo src={tenant?.logoUrl} alt="" id="logo" />
              )}
              {!backBtn ? (
                <SLink to="/sidebar" id="sidemenuIcon">
                  <SSideMenu />
                </SLink>
              ) : (
                <SBalanceSpace role="whiteSpace" />
              )}
            </>
          )}
          {isMessageLayout && to && (
            <>
              <SLink to={to} onClick={e => backBtnCallBack && backBtnCallBack(e)} role="backButton">
                {backgroundColor ? <BackBtnWhite /> : <BackBtn />}
              </SLink>
              <SHeaderMessageWrapper
                id="headerMessageWrapper"
                pointer={!!handleHeaderContentClick}
                onClick={handleHeaderContentClick}
              >
                <HeaderMessageText id="headerMessage">
                  {noTranslate
                    ? _.truncate(message, { length: 52 })
                    : translate(_.truncate(message, { length: 52 }))}
                </HeaderMessageText>
                {subMessageText && (
                  <SSubMessageText id="headerSubmessage" type={subMessageType}>
                    {subMessageText}
                  </SSubMessageText>
                )}
              </SHeaderMessageWrapper>
              {/* improve the implementation if more than 2 buttons variant needed  */}
              {showDots ? (
                <SDots
                  id="headerMoreDots"
                  role="menu"
                  width={32}
                  src={DotsHorizontal}
                  alt=""
                  onClick={dotsCallBack}
                />
              ) : renderCustomRightButton ? (
                renderCustomRightButton()
              ) : (
                <SBalanceSpace role="whiteSpace" />
              )}
            </>
          )}
        </SHeader>
        <SilentModeHeader />
        {belowHeaderContent}
      </SHeaderContent>
    </SHeaderWrapper>
  );
};
